module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("D")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dactyliomancy; dadilomancy:")]), _vm._v(" An ancient form of divination by means of a ring.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dactyls:")]), _vm._v(" Legendary magicians, soothsayers and occult healers, who spread from ancient Phrygia to Italy, Crete and Greece.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dagda:")]), _vm._v(" A god in pre-Christian Irish mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dakhma:")]), _vm._v(" The “tower of silence” where Zoroastrianists leave the bodies of their dead to be devoured by vultures.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dakshinamurthi:")]), _vm._v(" In Hinduism and occult philosophy, a manifestation or aspect of Shiva who “teaches in silence.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dalai Lama:")]), _vm._v(" The temporal head of Lamaism, regarded as the incarnation of the most widely revered "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bodhisattva")]), _vm._v(" (q.v.), Avalokiteshvara.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Danu:")]), _vm._v(" In ancient Irish mythology, the goddess of knowledge and culture, daughter of the god Dagda.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Daoine sithe:")]), _vm._v(" In Scots Gaelic, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("men of peace,")]), _vm._v(" a name for fairies.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Daphnomancy:")]), _vm._v(" Divination by interpreting the crackling of a laurel branch thrown into the fire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Darshan:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sight.")]), _vm._v(" When a Hindu spiritual leader allows his disciples to enjoy the gift of his presence, he is said to “give them "), _c('em', {
    staticClass: "i"
  }, [_vm._v("darshan")]), _vm._v(".” The word is used also in the meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("philosophical system")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("doctrine.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dark Night of the Soul:")]), _vm._v(" The final phase in the growth of the New Man, the complete purification of the soul which paves the way to the mystic union with God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dasa-bhumi:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ten stages.")]), _vm._v(" In Buddhist terminology, the ten stages of the spiritual development of a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bodhisattva")]), _vm._v(" (q.v.) toward Buddhahood. Each school of Buddhism has its own "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dasa-bhumi,")]), _vm._v(" but the most widely accepted set in Mahayana Buddhism is that set forth in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi Sastra,")]), _vm._v(" viz.: (1) The Stage of Joy, in which the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bodhisattva")]), _vm._v(" develops his holy nature and discards wrong views; (2) the Stage of Purity, in which he attains the Perfection of Morality; (3) the Stage of Illumination, in which he attains the Perfection of Patience or Humility, and also the deepest introspective insight; (4) the Stage of Flaming Wisdom, in which he achieves the Perfection of Meditation and realizes the harmony of the Worldly Truth and the Supreme Truth; (5) the Stage of Presence, in which he achieves the Perfection of Wisdom; (7) the Stage of Far-going, in which he attains the Perfection of Expediency by going afar and to save all beings; (8) the Stage of Immovability, in which he attains the Perfection of Vow and realizes the principle that all specific characters of elements ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("dharmas")]), _vm._v(") are unreal; (9) the Stage of Good Wisdom, in which he achieves the Perfection of Effort, attains the Ten Holy Powers, and preaches both to the redeemable and the unredeemable; (10) the Stage of the Cloud of the Law, in which he attains mastery of Perfect Knowledge and preaches the Law to save all creatures, “like the cloud drops rain over all.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day of Yahweh:")]), _vm._v(" In Hebrew mysticism, the Day of Judgment.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dead man’s candles:")]), _vm._v(" Luminous phenomena which according to folklore indicate impending death.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Death coach:")]), _vm._v(" The coach in which according to a superstitious belief found in many countries, Death makes its rounds, calling for souls to take along.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Debility:")]), _vm._v(" An embracive term in astrology, preferably applied to any planet disadvantageously placed by virtue of its House position; the opposite of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dignity")]), _vm._v(" (q.v.). Frequently employed loosely as a synonym of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Detriment")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Decad:")]), _vm._v(" In numerology, the number Ten.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Decumbiture:")]), _vm._v(" In astrological parlance, an horary figure erected for the moment when a person is taken ill, to serve as basis for astrological judgment as to the possible nature, prognosis and duration of the illness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deer:")]), _vm._v(" In Chinese occult symbology, a symbol of honor. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fu lu shou.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Defensive magic:")]), _vm._v(" The use of magic rituals, incantations, etc., for averting or overcoming evil influences.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deicide:")]), _vm._v(" Literally, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("god-killing.")]), _vm._v(" The killing of a totem animal or of a priest-kind in primitive religions, either real or symbolic.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deiknymena:")]), _vm._v(" Esoteric knowledge taught or explained by visual demonstration. (The term originates from the Eleusinian mysteries.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deism:")]), _vm._v(" The belief in one God, creator of the universe, as detached from the world and making no revelations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Déjà vu:")]), _vm._v(" French for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("already seen.")]), _vm._v(" The feeling that one has seen somebody or something in the past, even though knowing that he could never have actually. The phenomenon is variously explained by occultists as memory from a previous incarnation, a “memory of the future,” etc. The term is extended to apply also to such feelings of familiarity with words or sounds (properly "), _c('em', {
    staticClass: "i"
  }, [_vm._v("déjà entendu,")]), _vm._v(" “already heard”), etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Decoction:")]), _vm._v(" An alchemical term for the practice of dissolving or decomposing a substance by boiling it in a solvent; also, the solution obtained by this process.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Delphic oracle:")]), _vm._v(" The famous oracle in ancient Greece, where the seeress Pythia, in a state of trance, answered questions about the future.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demi-god:")]), _vm._v(" In polytheistic religions, the offspring of a god or goddess and a human being. Also, a human being deified after his death.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demiurge:")]), _vm._v(" Greek ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("demiurgos")]), _vm._v(") for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("worker for the people")]), _vm._v("—an old Greek term for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("craftsman.")]), _vm._v(" In Platonic philosophy, the term was applied to the Creator of the World, and the Gnostics used it in this sense to designate the inferior deity, creator of the evil world of matter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demon:")]), _vm._v(" While the term originally meant any superhuman being, benevolent or malevolent, lacking the dignity of a deity, it is customarily used today as meaning an evil entity, hostile to human beings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demon of Socrates:")]), _vm._v(" The guiding spirit who forewarned the ancient Greek philosopher Socrates of dangers.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demonocracy:")]), _vm._v(" The religion of primitive tribes of devil-worshippers; the belief in the rule by demons and evil spirits.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demonographer:")]), _vm._v(" An author who writes about demons and things connected with them and their doings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demonography:")]), _vm._v(" The literature of demonology (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Demonology:")]), _vm._v(" The study of demons and their characteristics, their classification, etc.; a theory of demonic behavior.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Depersonalization:")]), _vm._v(" The loss of the sense of personal identity or the sensation of being without material existence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dermography:")]), _vm._v(" The appearance of writing on the skin of a medium, remaining visible for a few minutes to a few hours.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dervish:")]), _vm._v(" A member of one of the Moslem orders or brotherhoods of mystic ascetics.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Descending arc:")]), _vm._v(" In theosophical occultism, the descent of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("monads")]), _vm._v(" (q.v.) from the higher spiritual planes or globes of existence downwards to or toward the physical level of existence. (Also called shadowy arc.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Determinism:")]), _vm._v(" The doctrine that every fact in the universe is guided entirely by law and is dependent upon and conditioned by causes. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Karma")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Detriment:")]), _vm._v(" An astrological term for the placement of a planet in the opposite sign from that of which it is said to be the Ruler; it is frequently applied also to "), _c('em', {
    staticClass: "i"
  }, [_vm._v("debility")]), _vm._v(" by sign position, which includes the opposite sign to that in which it is in its exaltation, as well as to those of which it is ruler.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Deva:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("radiant being.")]), _vm._v(" In the Vedic mythology and occult terminology, a celestial being, a god, a malignant supernatural entity or an indifferent supernatural being. The general designation for God in Hinduism. In Zoroastrianism, the name of the evil spirits opposed to Ahura Mazda. In Buddhism, a hero or demigod.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Devachan:")]), _vm._v(" A Sanskrit term for the intermediate state between two subsequent incarnations.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Devadatta:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("god-given;")]), _vm._v(" in Yoga, that one of the five vital airs ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("vayu")]), _vm._v(") of the body which performs the function of yawning.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Devanagari:")]), _vm._v(" Literally, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("letters of the gods;")]), _vm._v(" the characters of the Sanskrit script.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Devil:")]), _vm._v(" The chief of the evil demons. In later Jewish and early Christian usage, he was identified with Satan and regarded as the source of all evil, bent upon enslaving mankind.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Devil "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("worship:")]), _vm._v(" The worship, common among primitive or savage tribes and races, of evil demons. Specifically, the worship of Satan or Lucifer.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dhamma")]), _vm._v(": The Pali version of dharma (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dhanamjaya")]), _vm._v(": A Sanskrit term, literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("prize-winner;")]), _vm._v(" in Yoga, that one of the five vital airs (vayu) of the outer body which performs the function of hiccuping.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dharma")]), _vm._v(": Sanskrit for law; when used in the metaphysical or esoteric sense, it means those universal laws of Nature that sustain the operation of the Universe and the manifestations of all things; when applied to the individual, it has reference to that code of conduct that sustains the soul, and produces virtue, morality, or religious merit leading toward the development of man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dhyana:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("meditation")]), _vm._v(" or the full accord of thinker and thought without interference and without being merged as yet; the seventh of the eight stages of Yoga.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Diakka:")]), _vm._v(" A term introduced by A. J. Davis for mischievous spirits communicating with or harassing the living from Summerland (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Diana:")]), _vm._v(" The Roman goddess of the hunt.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dichotomy:")]), _vm._v(" Literally, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("a division into two parts.")]), _vm._v(" In a specific example: the view that man consists of soul and body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dignity:")]), _vm._v(" In astrological terminology, a condition of placement wherein a planet’s influence is strengthened; conditions of placement in which the planet’s influence is weakened are termed "), _c('em', {
    staticClass: "i"
  }, [_vm._v("debilities.")]), _vm._v(" (Dignities and debilities are of two varieties: essential and accidental.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dii adscripticii:")]), _vm._v(" The collective name of the minor gods of Roman mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dingir:")]), _vm._v(" An ancient Sumerian word for god or deity, and in general for any superhuman and immortal being.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dionysian mysteries:")]), _vm._v(" The ancient Greek mystery cult, originating in Phrygia, observed at various places by migratory groups of adherents. Originally, the rites were highly orgiastic in character; the devotees imbibed the sacred wine, ate the raw flesh of the sacrificed animal and drank its warm blood, and went into a frenzy of ecstasy, believed to be inspired by the presence of the deity within them. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Orphic mysteries.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Direct drawing:")]), _vm._v(" A mediumistic phenomenon, consisting in the production of a drawing without the direction of the conscious will of the medium, and without the use of his hands. A further development of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("automatic drawing")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Direct painting:")]), _vm._v(" A mediumistic phenomenon analogous to "), _c('em', {
    staticClass: "i"
  }, [_vm._v("direct drawing")]), _vm._v(" (q.v.), but resulting in the production of a painting. A further development of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("automatic painting")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Direct voice:")]), _vm._v(" A mediumistic term for an isolated voice resounding in space without any visible agency or source. At most seances it issues forth from a trumpet which floats about in the room, serving as a condenser, although it has been heard at many seances without a trumpet, sounding from various parts of the room.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Direct writing:")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Automatic writing")]), _vm._v(" (q.v.) produced without any visible physical contact with the medium, and occasionally also without any writing material present.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Discarnate:")]), _vm._v(" Existing outside of or without a physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Disciple:")]), _vm._v(" A follower or student of a school, doctrine or teacher.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Disembodied:")]), _vm._v(" Separated from the body; usually applied to the mind or intelligence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dispeller of darkness:")]), _vm._v(" The name given by occultists to a teacher or guide toward enlightenment ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("guru")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dispositor:")]), _vm._v(" In astrological terminology, the Ruler of the Sign on the cusp of a House is called the dispositor of a planet posited in that House.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Div:")]), _vm._v(" The counterpart in Persian mythology of the devil of medieval Europe.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Divination:")]), _vm._v(" The use of occult, esoteric or spiritualistic means, skill or practices for gaining knowledge of the unknown or of the future.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Divine Nothingness:")]), _vm._v(" In Jewish mysticism, the principle taught by the Habad school, that “the Divine is without limitation and opposed to all ‘something,’ which is limited. The divine is the ‘nothing’ that subsumes all limitation and finiteness.” (M. Buber)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Divine Science Church:")]), _vm._v(" A religious sect based on the doctrine of divine healing, founded by Melinda E. Cramer in 1885.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Divining rod:")]), _vm._v(" A V-shaped wooden (hazel) twig or piece of wire, whale bone, etc., 6 to 18 inches in length, used by dowsers to locate underground springs, lodes of metal, or other objects of search. The rod is held rigidly in the hands of the dowser, and a force (called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("rhabdic force")]), _vm._v(") coming from underground, is said to cause it to snap over, revolve or change its shape.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Doda ignorantia:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("learned ignorance;")]), _vm._v(" it refers to men’s knowledge of God which unavoidably includes a negative element, since He immeasurably surpasses the knowledge of Him gleaned from this phenomenal world, yet for man this is truly a real learning. Title given to one of his philosophical treatises by Nicholas of Cusa (1401–1464) who understood it in the sense of an insight into the incomprehensibility of the infinite.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dolmen:")]), _vm._v(" A Celtic name given to a. structure of two or more upright monoliths supporting a flat roof-stone; dolmens are generally believed to have been tombs, but some authorities assume that they were primitive temples.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Door of the dead:")]), _vm._v(" A special opening made in the wall of a house through which to remove a corpse, in order to prevent the ghost of the deceased from finding its way back to plague the survivors. The door of the dead is usually walled up again after the corpse has been removed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Doppelgänger:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double:")]), _vm._v(" A synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Doppelgänger")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double-bodied signs:")]), _vm._v(" The astrological signs Gemini, Sagittarius and Pisces, so called because their symbols represent two Figures. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dual")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("bicorporeal signs")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dowser:")]), _vm._v(" A sensitive who has the ability to locate underground springs and other objects below the surface of the earth by the use of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("divining rod")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dowsing:")]), _vm._v(" The search for and location of underground springs and other objects under the surface of the earth, by the use of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("divining rod")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dravya:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("substance,")]), _vm._v(" which is the foundation of the universe and is resolved into nine Eternal Realities, viz. (1) Earth ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Prthivi")]), _vm._v("), (2) Water ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Apas")]), _vm._v("), (3) Fire ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Tejas")]), _vm._v("), (4) Air ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Vayu")]), _vm._v("), (5) Ether ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Akasha")]), _vm._v("), (6) Time ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kala")]), _vm._v("), (7) Space ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dik")]), _vm._v("), (8) Soul ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Atman")]), _vm._v("), (9) Mind ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Manas")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dream body:")]), _vm._v(" A term which is more or less a synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dreaming true:")]), _vm._v(" The ability to control and have consciousness in one’s dreams.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Druids:")]), _vm._v(" Priest-magicians of the early Celts.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Druses:")]), _vm._v(" A religious sect in Asia Minor, whose faith combines teachings of the Mosaic law, the Christian Gospels, the Koran and the Sufi allegories; they believe in one God, transmigration of the soul, constant spiritual evolution and final perfection.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dryad:")]), _vm._v(" In Greek mythology, a tree-spirit which lives in a tree and dies when the tree is cut down or dies.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Duad:")]), _vm._v(" A pair of deities, one good or beneficent, the other evil or malignant.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dual signs:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Doubled-bodied signs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dualism:")]), _vm._v(" The doctrine that there exist two opposed and mutually antagonistic divine or cosmic forces—one good, the other evil. The belief in a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("duad")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dukhobortsy:")]), _vm._v(" Russian for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("wrestlers with the spirit.")]), _vm._v(" A Russian religious sect professing mystical doctrines and striving for “spiritual understanding.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dumb signs:")]), _vm._v(" The astrological signs Cancer, Scorpio and Pisces. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("mute signs")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Duration:")]), _vm._v(" A limited extent of existence in time, more or less long, from a fraction of a second to countless ages.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dvaita:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dualism;")]), _vm._v(" that school of Hindu philosophy which denies that the Ultimate Principle ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Brahman")]), _vm._v(") is the cause of the world, and contends that the soul is a separate principle having an independent existence of its own, and is only associated with the Ultimate Principle.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dwapara yuga:")]), _vm._v(" Sanskrit name of the third age ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("yuga")]), _vm._v(") of a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manvantara;")]), _vm._v(" a fourth less righteous than the preceding one, and lasting 864,000 of our years (two-tenths of the entire "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manvantara")]), _vm._v(" ).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dweller:")]), _vm._v(" An occult term for malignant or hostile astral doubles of the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dweller in the body:")]), _vm._v(" The Spirit ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("purusha")]), _vm._v("—q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dweller on the Threshold:")]), _vm._v(" In occult terminology, a demon or evil elemental or nature-spirit capable of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("obsession")]), _vm._v(" (q.v.). The term was coined by Bulwer Lytton.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dyad:")]), _vm._v(" In numerology, the number Two.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dyaus:")]), _vm._v(" The ancient Aryan god of the sky.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dynamistograph:")]), _vm._v(" A complicated mechanical instrument built, allegedly under spirit guidance, by two Dutch physicians for establishing direct communication with the spirit world without using a medium.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dysteleology:")]), _vm._v(" The term for the forbidding and frustrating aspects of life (such as unfavorable environmental factors, organic maladaptations, the struggle for existence, disease, death, etc.) which make difficult, if not impossible, the theory that there are good purposes predominantly at work in the world.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dzyan:")]), _vm._v(" The Tibetan equivalent of the Buddhist term "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dhyana")]), _vm._v(" (q.v.).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef07a738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c04.vue
// module id = 84
// module chunks = 0